import { ReferenceInput, AutocompleteInput, required, TextInput, NumberInput, SelectInput } from "react-admin";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { SectionTitle } from "features/SectionTitle";
import { NotOnlinePaidMethods } from "utils/constants";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";

const BirthAndEducationInfo = ({ userData, specialityId }) => {
  return (
    <>
      {/* //BirthData */}
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle paddingY={2} title="Място на раждане" />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            reference={administrationRequests.getCountriesSelect()}
            source="birthCountryId"
          >
            <AutocompleteInput
              defaultValue={userData?.birthCountryId || null}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              optionText="nameBg"
              label="Държава"
              validate={required("Задължително")}
              fullWidth
            />
          </ReferenceInput>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            defaultValue={userData?.birthSettlement || null}
            label="Населено място"
            source="birthSettlement"
            validate={required("Задължително")}
          />
        </Grid>

        <Grid
          item
          md={4}
        >
          <CustomDateInput
            fullWidth
            source="birthDate"
            label="Дата на раждане"
            defaultValue={userData?.birthDate || null}
            validate={required("Задължително")}
            required
          />
        </Grid>
      </Grid>
      {/* //EducationData */}
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle paddingY={2} title="Приет в" />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="targetSpecialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
          >
            <SelectInput
              readOnly={userData?.targetSpecialityId || specialityId}
              defaultValue={userData?.targetSpecialityId || specialityId || null}
              label="Специалност"
              validate={required("Задължително")}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <NumberInput
            onWheel={e => e.target.blur()}
            source="studyGroup"
            label="Учебна група"
            validate={required()}
          />
        </Grid>
        {specialityId && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="instructionLanguageId"
              reference={administrationRequests.getInstructionLanguagesBySpecialityId(specialityId)}
            >
              <AutocompleteInput
                optionText="nameBg"
                optionValue="id"
                label="Език на обучение"
                validate={required("Задължително")}
                defaultValue={userData?.instructionLanguageId}
                readOnly={userData?.instructionLanguageId}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="academicYearId"
            reference={studentRequests.getAcademicYearsSelect()}
          >
            <SelectInput
              label="Академична година"
              helperText={false}
              validate={required()}
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <CustomDateInput
            source="orderDate"
            label="Дата на заповед"
            required
            validate={required()}
            helperText={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            source="orderNumber"
            label="Номер на заповед"
            validate={required()}
            helperText={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <SelectInput
            label="Тип плащане"
            source="paymentMethod"
            choices={NotOnlinePaidMethods}
            validate={required()}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default BirthAndEducationInfo;
